/**
 * Checkout buttons: instant busy state, and an optional straight route to the
 * standard Shopify checkout.
 *
 * Shopify takes a second or two to build the checkout after the cart form
 * posts, and the browser shows nothing in that gap, so the submitting button is
 * marked busy right away. When "skip Shop Pay redirect" is on in theme settings
 * the form post is replaced by a visit to /checkout?skip_shop_pay=true, which
 * bypasses Shop Pay's automatic takeover for recognised customers. Shop Pay is
 * still offered as a payment method on the checkout page itself.
 */
(() => {
  const script = document.currentScript;
  const skipShopPay = Boolean(script && script.dataset.skipShopPay === 'true');
  const isCheckoutSubmit = (event) => event.submitter && event.submitter.name === 'checkout';

  const markBusy = (button) => {
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
  };

  // Listens on window so any script that cancels the submit has already run.
  window.addEventListener('submit', (event) => {
    if (!isCheckoutSubmit(event) || event.defaultPrevented) return;
    markBusy(event.submitter);
    if (!skipShopPay) return;
    event.preventDefault();
    window.location.assign('/checkout?skip_shop_pay=true');
  });

  window.addEventListener('pageshow', () => {
    for (const button of document.querySelectorAll('[name="checkout"].loading')) {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
    }
  });
})();
